import React from "react";

function Continue(props) {
  return (
    <div>
      <h2>... And You’re Set!</h2>
      <button
        className="my-3 px-5 text-uppercase btn btn-md btn-primary text-uppercase"
        onClick={props.onContinue}
      >
        Continue
      </button>
    </div>
  );
}
export default Continue;
